module.exports = __webpack_public_path__ + "canada.4d2c0a19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/flags/canada.png
// module id = 1495
// module chunks = 0